var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFashionLuxury = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Dress-2--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Dress 2 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.55 17.2a0.25 0.25 0 0 0 0.16 -0.31l-1.49 -5a0.5 0.5 0 0 0 -0.61 -0.34A23.57 23.57 0 0 1 12 12a25.36 25.36 0 0 1 -4.61 -0.49 0.5 0.5 0 0 0 -0.61 0.34l-1.49 5a0.25 0.25 0 0 0 0.16 0.31 21.1 21.1 0 0 0 13.1 0.04Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.94 21 -0.66 -2.22a0.23 0.23 0 0 0 -0.12 -0.15 0.25 0.25 0 0 0 -0.19 0 22.81 22.81 0 0 1 -7 1.11 22.81 22.81 0 0 1 -7 -1.11 0.25 0.25 0 0 0 -0.19 0 0.23 0.23 0 0 0 -0.12 0.15L4.06 21A1.49 1.49 0 0 0 5 22.84 19.93 19.93 0 0 0 12 24a19.93 19.93 0 0 0 7.05 -1.16 1.49 1.49 0 0 0 0.89 -1.8Z",
    fill: "currentColor",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.13 4.39a0.23 0.23 0 0 1 -0.13 -0.21V1a1 1 0 0 0 -2 0v2.85a0.25 0.25 0 0 1 -0.16 0.23 1.14 1.14 0 0 0 -0.47 0.35l-1.09 1.64a0.31 0.31 0 0 1 -0.56 0l-1.09 -1.64a1.14 1.14 0 0 0 -0.47 -0.35 0.25 0.25 0 0 1 -0.16 -0.23V1a1 1 0 0 0 -2 0v3.18a0.23 0.23 0 0 1 -0.13 0.21 2.54 2.54 0 0 0 -1.22 3.07l0.84 2.29a0.49 0.49 0 0 0 0.37 0.31 19.59 19.59 0 0 0 8.28 0 0.49 0.49 0 0 0 0.37 -0.31l0.84 -2.29a2.54 2.54 0 0 0 -1.22 -3.07Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFashionLuxury);
export default ForwardRef;